// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:960px){.min-h-scroll[data-v-d2e8d056]{height:75vh;overflow-y:scroll}}.border[data-v-d2e8d056]{border:.5px solid rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;
